<div class="not-found-container">
  <div class="text-container">
    <table>
      <tr>
        <td rowspan="2" class="number-text">404</td>
        <td class="sorry-text">Sorry,</td>
      </tr>
      <tr>
        <td class="small-text">This wans’t what you <br>were looking for.</td>
      </tr>
    </table>
  </div>
  <div class="button-container">
    <button (click)="backAway()">Take me back</button>
  </div>
</div>
